import {default as i18n, default as i18next} from "i18next";
import LngDetector from 'i18next-browser-languagedetector';
import * as de from './de/common.json';
import * as fr from './fr/common.json';
import * as it from './it/common.json';
import * as en from './en/common.json';
import * as et from './et/common.json';
import * as fi from './fi/common.json';
import * as lt from './lt/common.json';
import * as lv from './lv/common.json';
import {
    ActionType,
    CurrencyProps,
    CURRENT_CURRENCY,
    DEFAULT_LANGUAGES,
    Language,
    NUMBER_FORMAT_DECIMAL
} from "App/constants";
import {ApplicationState} from "App/store";
import * as numeral from "numeral";
import {initReactI18next} from "react-i18next";
import {ThunkDispatch} from "redux-thunk";
import {AnyAction} from "redux";
import {selectedLang} from "App/helper";

const DEFINED_LANGUAGES_TEXTS: string[] =  Object.keys(Language).map(key => Language[key]);
const enable_languages: Language[] = (process.env.REACT_APP_ENABLE_LANGUAGES||'').split(',')
    .filter(value => DEFINED_LANGUAGES_TEXTS.includes(value.trim()))
    .reduce((res, value) => {
        res.push(<Language>value);
        return res;
    }, new Array<Language>());

// Register numeral locales
// FIXME register supplemental locales?
numeral.register('locale', 'de-ch', {
    delimiters: {
        thousands: '\'',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return '.';
    },
    currency: {
        symbol: CURRENT_CURRENCY
    }
});
numeral.locale('de-ch');

// Initialize i18n
i18next
    .use(LngDetector)
    .use(initReactI18next)
    .init({
        load: 'languageOnly',
        fallbackLng: enableLanguages()[0],
        debug: true,
        interpolation: {
            escapeValue: false,
            formatSeparator: ';',
            format: function (value, formatting, lng) {
                return numeral(value).format(formatting ? formatting : NUMBER_FORMAT_DECIMAL);
            }
        },
        whitelist: enableLanguages(),
        resources: {
            de: {
                common: de
            }, fr: {
                common: fr
            }, it: {
                common: it
            }, en: {
                common: en
            }, et: {
                common: et
            }, fi: {
                common: fi
            }, lt: {
                common: lt
            }, lv: {
                common: lv
            }
        },
        react: {
            wait: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        },
        defaultNS: 'common',
        detection: {
            order: ['querystring', 'navigator'],
            lookupQuerystring: 'lng'
        }
    });

export {i18next};

export const mapI18nStateToProps = (state: ApplicationState): CurrencyProps => ({
    currency: state.currency
});

export function selectLanguageAction(language: Language): any {

    return async function (dispatch: ThunkDispatch<any, null, AnyAction>) {

        var currentLanguage: Language = selectedLang(i18n);
        if (language && language !== currentLanguage) {
            i18next.changeLanguage(language);
            dispatch({
                type: ActionType.LANGUAGE_SELECTION,
                language: language
            });
        }
    };
}

export function enableLanguages(): Language[] {
    return enable_languages&&enable_languages.length&&enable_languages||DEFAULT_LANGUAGES;
}



// WEBPACK FOOTER //
// ./src/translations/index.ts